import { ReactElement } from 'react';

import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';

import { Box, SxProps, Theme } from '@mui/material';

type BackrsUserBadgeProps = Readonly<{
  variant: 'professional' | 'student';
}>;

export const BackrsUserBadge = ({ variant }: BackrsUserBadgeProps): ReactElement => {
  const bgColor = variant === 'professional' ? appColors.color.navy3 : appColors.color.blue1;

  const label = variant === 'professional' ? 'B' : 'S';

  return (
    <Box
      sx={{
        ...backrsCircleStyle,
        backgroundColor: bgColor,
      }}
    >
      {label}
    </Box>
  );
};

const backrsCircleStyle: SxProps<Theme> = {
  position: 'absolute',
  bottom: '0px',
  right: '0px',
  width: '22px',
  height: '22px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  fontSize: '16px',
  fontWeight: 'bold',
  lineHeight: 1,
};
